import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/arcademy/icn_arcademy-01.png';
import icn_02 from '../../assets/img/landingPage/arcademy/icn_arcademy-02.png';
import icn_03 from '../../assets/img/landingPage/arcademy/icn_arcademy-03.png';
import icn_04 from '../../assets/img/landingPage/designer/icn_Desginer-02.png';


import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'
import logo from '../../assets/img/logos/AVAP_Arcademy_negativo.svg'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/arcademy/arcademy-dashboard.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const Arcademy = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'From gaming to coding—unleash the power of programming.',
            text: " AVAP Arcademy is built for curious teens and non-technical professionals looking to pivot into tech. Through hands-on video game development, the platform offers a playful yet powerful way to learn coding fundamentals—covering block-based programming, JavaScript, Python, and core API concepts from day one.",
            altDescription: "AVAP Arcademy is built for curious teens and non-technical professionals looking to pivot into tech. Through hands-on video game development, the platform offers a playful yet powerful way to learn coding fundamentals—covering block-based programming, JavaScript, Python, and core API concepts from day one.",
            image: icn_01,
        },
        Key_Feature_02: {
            title: "A partner-driven learning ecosystem",
            text: "AVAP Arcademy expands through a growing network of partners—including high schools, cultural institutions, coding academies, and independent learning centers. By tapping into the universal language of gaming, we transform curiosity into skill and motivation into real technical capability.",
            altDescription: "AVAP Arcademy expands through a growing network of partners—including high schools, cultural institutions, coding academies, and independent learning centers. By tapping into the universal language of gaming, we transform curiosity into skill and motivation into real technical capability.",
            image: icn_02,
        },
        Key_Feature_03: {
            title: 'Recognition that matters',
            text: "Participants earn badges and internal credentials designed to spotlight high-potential learners. These act as equivalents to certifications—offering a clear path for showcasing progress and commitment.",
            altDescription: 'Participants earn badges and internal credentials designed to spotlight high-potential learners. These act as equivalents to certifications—offering a clear path for showcasing progress and commitment.',
            image: icn_03,
        },
        Key_Feature_04: {
            title: 'Scalable by design',
            text: 
            "With a modular approach, AVAP Arcademy adapts easily to extracurricular and formal education settings—enabling fast rollout across regions, languages, and institutions.",
            altDescription: 'With a modular approach, AVAP Arcademy adapts easily to extracurricular and formal education settings—enabling fast rollout across regions, languages, and institutions.',
            image: icn_04,
        },
    }
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" 
                className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Cloud"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Discover Your Tech Side</h1>
                    <p className="fl-subtitle pb-0 fl-txt-container-s">
                    Turn curiosity into code through the universal language of gaming.
                    </p>
                </section>

                {/* Powerful API Platform */}
                <section className="text-center pb-8">
                    <img
                        src={dashboard}
                        alt="AVAP Cloud illustration displaying API Manager Service components including Devs & Organizations, Managed APIs, IAM, credentials, API Projects, API Catalog, Dev Portal, Gateway Manager, BRUNIX AI, and AI analytics."
                        className="img-fluid mt-4"
                        style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                    />
                    <h2 className="fl-title m-4 pt-8">AVAP Arcademy, Learn to Code Through Play</h2>
                    {/*<p className="fl-subtitle-xs mb-3">
                        Manage the entire API lifecycle in a SaaS model from <br /> design to testing and deployment.
                    </p>*/}
                    <p className="fl-text fl-txt-container-s">
                    AVAP Arcademy empowers teens and aspiring professionals to explore programming through interactive, game-based learning. Designed for both early exposure and career redirection, the platform blends creativity with real-world coding skills using block-based programming, JavaScript, Python, and API fundamentals.
                    </p>
                    <p className="fl-text fl-txt-container-s">
                    Built on partnerships with schools, cultural centers, and tech academies, AVAP Arcademy makes tech education fun, accessible, and scalable—opening doors to future opportunities.
                    </p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                </section>

                

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Features</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-9">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*Boton Contact Us*/}  
                            <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                        </section>
                    </div>
                </div>

                <br />
                <br />
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Arcademy;
